import { checkParentTarget, conditions } from "helpers";
import useActiveInActive from "helpers/hooks/useActiveInActive";
import { ConditionName, zIndex } from "interfaces";
import { useEffect, useState } from "react"
import { handleFullScreen, handlePlayPause, handleVideoElementSizeInfo } from "redux-share/actions";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import PlayerCore from "../../player-core/playerCore";
import { setShowMiniPlayer } from "redux-share/slices/controllerSlice";
import { shallowEqual } from 'react-redux';
import Image from 'next/image';
import dynamic from "next/dynamic";

const Header = dynamic(() => import("../../mainComponent/header/header"));
const Main = dynamic(() => import("../../mainComponent/main/main"));
const Footer = dynamic(() => import("../../mainComponent/footer/footer"));
const Gif = dynamic(() => import("../../player-components/gif/gif"));
const BackwardForward = dynamic(() => import("../../player-components/backwardForward/backwardForward"));
const TouchVolumeBrightness = dynamic(() => import("../../player-components/touchVolumeBrightness/touchVolumeBrightness"));
const CloseIcon = dynamic(() => import("../../icon-components/closeIcon"));

const VideoArea = () => {

    const [isRightDoubleTouched, setIsRightDoubleTouched] = useState<boolean>(false);
    const [isLeftDoubleTouched, setIsLeftDoubleTouched] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const { gif, details } = useAppSelector(({ videoData: { gif, details, params, videoElementSizeInfo } }) => ({ gif, details, params, videoElementSizeInfo }), shallowEqual);
    const { showMiniPlayer } = useAppSelector(({ controller: { showMiniPlayer, isFullScreen } }) => ({ showMiniPlayer, isFullScreen }), shallowEqual);

    const handleDoubleClick = (event: any) => {
        if (!conditions(ConditionName.isTouchScreen) && !checkParentTarget(event, "emojiButtonLeft") && !checkParentTarget(event, "emojiButtonRight") && !checkParentTarget(event, "menuIconLeft") && !checkParentTarget(event, "menuIconRight")) handleFullScreen();
    }

    // --- Managing the active and inActive of elements in desktop and mobile devices --- //
    useActiveInActive(isRightDoubleTouched, isLeftDoubleTouched);

    useEffect(() => {
        const timeout = setTimeout(() => handleVideoElementSizeInfo(), 100)

        return () => clearTimeout(timeout);
    }, [showMiniPlayer])

    return (
        <>
            {conditions(ConditionName.showMiniPlayer) && <div id="black-video-area" className="pl-relative pl-w-full pl-aspect-video pl-bg-black" />}
            <div
                id="video-area"
                style={{ zIndex: conditions(ConditionName.showMiniPlayer) ? zIndex.videoPlayerInPictureInPicture : 'unset' }}
                onClick={(event) => conditions(ConditionName.playByClickPoster) && handlePlayPause(event)}
                onDoubleClick={handleDoubleClick}
                className={`!pl-bg-contain !pl-bg-center !pl-bg-no-repeat pl-h-full pl-bg-black pl-max-h-screen pl-aspect-video pl-flex pl-items-center pl-w-full pl-relative ${conditions(ConditionName.isFullScreen) && '!pl-w-screen !pl-h-[100dvh]'}`}
            >
                {conditions(ConditionName.showBanner) && <div className='pl-absolute pl-w-full pl-h-full pl-flex pl-justify-center'>
                    <Image src={details.banner} layout='fill'  alt="sdfdf" objectFit="contain"/>
                </div>}
                {conditions(ConditionName.showMiniPlayer) && <CloseIcon className="pl-w-4 pl-h-4 pl-stroke-black pl-bg-white pl-absolute pl-top-[-7px] pl-right-[-5px] pl-z-10 pl-cursor-pointer pl-rounded-full" onClick={() => dispatch(setShowMiniPlayer(undefined))}/>}
                {(conditions(ConditionName.showTouchVolumeBrightness) && !conditions(ConditionName.isMiniPlayer)) && <TouchVolumeBrightness />}
                {conditions(ConditionName.showBackwardForward) && (
                    <div className={`pl-absolute pl-top-0 pl-right-0 pl-w-full pl-h-full pl-overflow-hidden pl-flex pl-items-center`}
                        style={{ zIndex: (isLeftDoubleTouched || isRightDoubleTouched) ? zIndex.backwardForwardActive : zIndex.backwardForwardInActive }}>
                        <BackwardForward type="touchForward" isRightDoubleTouched={isRightDoubleTouched}
                            setIsRightDoubleTouched={setIsRightDoubleTouched} />
                        <BackwardForward type="touchBackward" isLeftDoubleTouched={isLeftDoubleTouched}
                            setIsLeftDoubleTouched={setIsLeftDoubleTouched} />
                    </div>
                )}
                <PlayerCore />
                {!conditions(ConditionName.isRaw) && (
                    <div id="playerElements" className={`pl-absolute pl-top-0 pl-right-0 pl-w-full pl-h-full ${!conditions(ConditionName.isTouchScreenPortrait) && "pl-overflow-hidden"}`}>
                        <div className={`pl-flex pl-flex-col pl-justify-between pl-w-full pl-h-full`}>
                            {conditions(ConditionName.showHeader) && <Header />}
                            {conditions(ConditionName.showMain) && <Main />}
                            {conditions(ConditionName.showFooter) && <Footer />}
                            {conditions(ConditionName.showGif) && <Gif gif={gif!} />}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default VideoArea;